export default "__VITE_ASSET__BrtPxgcu__"